<template>
  <div id="app">
    <Calendar :v-if="info.length >= 0" :info="info"
              v-on:month-change="getData"/>
  </div>
</template>

<script>
import axios from 'axios'
import Calendar from './components/Calendar.vue'

let currentDate = new Date();

export default {
  name: 'App',
  components: {
    Calendar
  },
  data() {
    return {
      info: [],
    }
  },
  methods: {
    getStringDate(month, day, year) {
      let mm = (month < 10) ? ("0"+month) : month;
      let dd = (day < 10) ? ("0"+day) : day;
      return year + "-" + mm + "-" + dd;
    },
    getData(startDate) {
      axios
      .get('https://events.brown.edu/live/json/events/description_long/true/group/Center%20for%20Computation%20and%20Visualization%20%28CCV%29/start_date/'
      + startDate + '/')
      .then(response => {
        this.info = response.data;
      })
    }
  },
  mounted() {
    let firstOfLastMonth = this.getStringDate(currentDate.getMonth(), 1, currentDate.getFullYear());
    this.getData(firstOfLastMonth);
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
